import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiObjectData } from '../models/api-object-data';
import { Company } from '../models/company';
import { BaseService } from './base.service';

@Injectable({
    providedIn: 'root'
})
export class CompanyService {

    controller = 'company';

    constructor(private base: BaseService) { }

    get(id): Observable<ApiObjectData> {
        return this.base.get(id, this.controller);
    }

    gets(): Observable<ApiObjectData> {
        return this.base.gets(this.controller);
    }

    save(obj: Company) {
        return this.base.save(this.controller, obj);
    }

    remove(id: number) {
        return this.base.remove(this.controller, id);
    }
}
